import { render } from "./ChatwallViewer.vue?vue&type=template&id=2d630508&scoped=true"
import script from "./ChatwallViewer.vue?vue&type=script&lang=js"
export * from "./ChatwallViewer.vue?vue&type=script&lang=js"

import "./ChatwallViewer.vue?vue&type=style&index=0&id=2d630508&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d630508"]])

export default __exports__